function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { useState } from "react";
import styles from "./ShoppingDetail.module.css";
// import { Api } from "../../../../uikit/service/api";
import { useEnableScroll } from "../../hooks/useEnableScroll";
import { NodesUtil } from "../NodesUtil";
import cls from "classnames";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import { isEmpty } from "lodash";
var ShoppingDetail = function ShoppingDetail(_ref) {
  var _onClick = _ref.onClick,
    shoppingInfo = _ref.shoppingInfo,
    featureTags = _ref.featureTags;
  // const api = new Api(false);

  var _useEnableScroll = useEnableScroll(),
    enableScroll = _useEnableScroll.enableScroll,
    mouseEnterLeave = _useEnableScroll.mouseEnterLeave;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    buySuccessText = _useState2[0],
    setBuySuccessText = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    buyButtonLoading = _useState4[0],
    setBuyButtonLoading = _useState4[1];
  var urlStr = "http://35.163.73.88:8010/remote/buyProductFromJingdong?product_name=".concat(shoppingInfo.title);
  var url = "/be/svc-adapter/natural/proxy?url=".concat(encodeURIComponent(urlStr));
  var handleClick = function handleClick() {
    openLinkPage();
    e.stopPropagation();
    // setBuyButtonLoading(true);
    // api.get(url)
    //   .then((_) => {
    //     setBuyButtonLoading(false);
    //     message.success("Buy successfully");
    //     setBuySuccessText(
    //       "You order is being processed right now. Please add Natural to your Wechat for Beta users."
    //     );
    //   })
    //   .catch((error) => {
    //     setBuyButtonLoading(false);
    //     console.log(error);
    //     message.info("Buy failed");
    //   });
  };
  var openLinkPage = function openLinkPage() {
    var _shoppingInfo$link;
    var link = (_shoppingInfo$link = shoppingInfo.link) !== null && _shoppingInfo$link !== void 0 ? _shoppingInfo$link : shoppingInfo.view_link; // 目前weee使用的是view_link
    if (isEmpty(link)) {
      return;
    }
    window.open(link);
  };
  var noWheelClassName = enableScroll ? NodesUtil.constants.NO_WHEEL : "";
  var shoppingInfoClassName = cls(styles.shoppingInfo, noWheelClassName);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.ShoppingDetail,
    onMouseEnter: function onMouseEnter() {
      return mouseEnterLeave(true);
    },
    onMouseLeave: function onMouseLeave() {
      return mouseEnterLeave(false);
    },
    onClick: function onClick() {
      return openLinkPage();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.inner
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.backNav
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick(e) {
      _onClick();
      e.stopPropagation();
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "".concat(settings.S3CDN).concat(settings.viewAssetsPath, "rightArrow.svg"),
    alt: ""
  }), " Go back")), /*#__PURE__*/React.createElement("div", {
    className: shoppingInfoClassName
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.imgWrapper
  }, /*#__PURE__*/React.createElement("img", {
    src: shoppingInfo.image,
    alt: ""
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.desc
  }, shoppingInfo.title), /*#__PURE__*/React.createElement("div", {
    className: styles.desc
  }, buySuccessText), featureTags.showBuyButton && /*#__PURE__*/React.createElement("div", {
    className: styles.buyNowButton,
    onClick: handleClick
  }, "Buy now", /*#__PURE__*/React.createElement(Spin, {
    spinning: buyButtonLoading,
    indicator: /*#__PURE__*/React.createElement(LoadingOutlined, {
      style: {
        fontSize: 16,
        marginLeft: "15px",
        marginBottom: "5px"
      },
      spin: true
    })
  })))));
};
export default ShoppingDetail;